<div class="{{ 'toast-notification toast-notification--' + toastPackage.toastType }}">
  <div class="toast-notification__content">
    <div class="toast-notification__icon">
      <mat-icon
      [svgIcon]="getIconType()"></mat-icon>
    </div>
    <div class="toast-notification__message">
      <div
        data-testid="toast-text"
        [innerHtml]="toastPackage.message"
      ></div>
      @if (showReloadButton) {
        <div class="toast-notification__actions">
          <app-button matSnackBarAction type="primary" (buttonClick)="reload()" [size]="'small'" [dataTestId]="'toast-reload'">
            Reload Page
          </app-button>
        </div>
      }
    </div>

    <div class="toast-notification__close">
      @if (options.closeButton) {
        <app-button
          type="tertiary"
          (buttonClick)="removeToast()"
          [size]="'small'"
          [dataTestId]="'toast-close'"
          >
          <span class="fa fa-times"></span>
        </app-button>
      }
      @if (showLoadingSpinner) {
        <div class="loading-icon">
          <span class="fas fa-spin fa-circle-notch"></span>
        </div>
      }
    </div>
  </div>
</div>
